import client from "@/api/client";

const SOURCES = {
  entities: () => client.get("/entities"),
  categories: () => client.get("/payment-desk/categories"),
  vendors: () => client.get("/vendor-master/vendors/options"),
  sites: () => client.get("/site-master/sites/options"),
  equipment: () => client.get("/assets/options"),
  payeeEmployees: () => client.get("/payment-desk/payee-employees"),
};
export const REF_KEYS = Object.keys(SOURCES);

const state = Object.fromEntries(REF_KEYS.map((k) => [k, { data: [], loaded: false, promise: null }]));
const listeners = new Set();
let version = 0;
const notify = () => { version += 1; listeners.forEach((l) => l()); };

export const subscribeRef = (cb) => { listeners.add(cb); return () => listeners.delete(cb); };
export const getRefVersion = () => version;
export const getRef = (key) => state[key];

// Each list loads independently and is remembered for the session; a call
// while one is in flight shares that request. `force` re-fetches quietly
// (existing data stays visible meanwhile).
export function fetchRef(key, { force = false } = {}) {
  const s = state[key];
  if (s.promise) return s.promise;
  if (s.loaded && !force) return Promise.resolve(s.data);
  s.promise = SOURCES[key]()
    .then((res) => { s.data = res.data; })
    .catch(() => {})
    .finally(() => { s.loaded = true; s.promise = null; notify(); });
  return s.promise;
}

export function invalidateRef(key) {
  const s = state[key];
  s.loaded = false;
  s.data = [];
  notify();
  if (listeners.size > 0) fetchRef(key);
}

export function clearRefData() {
  REF_KEYS.forEach((k) => { state[k] = { data: [], loaded: false, promise: null }; });
  notify();
}

export function upsertVendorOption(v) {
  const s = state.vendors;
  if (!s.loaded) return;
  const rest = s.data.filter((x) => x.vendor_code !== v.vendor_code);
  if (v.active === false) {
    s.data = rest;
  } else {
    const opt = { vendor_code: v.vendor_code, vendor_name: v.vendor_name, category_code: v.category_code ?? null, bank_details_complete: !!v.bank_details_complete };
    s.data = [...rest, opt].sort((a, b) => (a.vendor_name < b.vendor_name ? -1 : a.vendor_name > b.vendor_name ? 1 : 0));
  }
  notify();
}
